// extracted by mini-css-extract-plugin
export default {"header":"AppHeader_header__nHHDe"};